import { roundToTwoDecimals } from 'utils/numbers';
import { checkIfNzHealthAndFitness } from './cancellationUtils';

// Cancellation Fee Validator
export const getCancellationFeeValidators = (
  getOtherFormValues,
  {
    cancelFee: cancelFeeLimit,
    balanceToSettleWithoutCancelFee,
    industryType,
    country,
    isBiPartite,
  }
) => {
  const isNzHealthAndFitness = checkIfNzHealthAndFitness(industryType, country);

  // If the cancellation fee limit is zero or null then the maximum amount is 500.
  const cancelFeeCheckLimit = cancelFeeLimit || 500;

  return {
    //Cancellation fee minimum value has to $1 for it be processed.
    nonNzHealthAndFitness: (value) => {
      if (isNzHealthAndFitness) return true;
      //Skip other threshold when account is biPartite by assigning minComparisonAmount to balanceToSettleWithoutCancelFee
      const minComparisonAmount = isBiPartite
        ? balanceToSettleWithoutCancelFee
        : Math.min(cancelFeeCheckLimit, balanceToSettleWithoutCancelFee);

      switch (minComparisonAmount) {
        case cancelFeeCheckLimit:
          return (
            value <= cancelFeeCheckLimit ||
            `Cancellation fee must not exceed $${cancelFeeCheckLimit.toFixed(
              2
            )}`
          );
        case balanceToSettleWithoutCancelFee:
          if (!balanceToSettleWithoutCancelFee) return true;
          return (
            value <= balanceToSettleWithoutCancelFee ||
            `Cancellation fee must not exceed the balance to settle amount of $${balanceToSettleWithoutCancelFee.toFixed(
              2
            )}`
          );
        default:
          return true;
      }
    },
    // If NZ HnF industry then the cancellation fee has to be less than $150 and less than 25% of balance to settle.
    nzHealthAndFitness: (value) => {
      if (!isNzHealthAndFitness) return true;
      const nzHfLimit = 150;
      //Skip other threshold when account is biPartite by assigning minComparisonAmount to balanceToSettleWithoutCancelFee
      const minComparisonAmount = isBiPartite
        ? balanceToSettleWithoutCancelFee
        : Math.min(
            cancelFeeCheckLimit,
            0.25 * balanceToSettleWithoutCancelFee,
            nzHfLimit
          );
      switch (minComparisonAmount) {
        case cancelFeeCheckLimit:
          return (
            value <= cancelFeeCheckLimit ||
            `Cancellation fee must not exceed $${cancelFeeCheckLimit.toFixed(
              2
            )}`
          );
        case nzHfLimit:
          return (
            value <= nzHfLimit || `Cancellation fee must not exceed $150.00`
          );

        case 0.25 * balanceToSettleWithoutCancelFee:
          // If the balance to settle is $1, then it might contradict the minimum value being $1. This is expected behaviour.
          return (
            value <=
              roundToTwoDecimals(0.25 * balanceToSettleWithoutCancelFee) ||
            `Cancellation fee must not exceed $${roundToTwoDecimals(
              0.25 * balanceToSettleWithoutCancelFee
            )} which is 25% of the balance to settle amount`
          );
        case balanceToSettleWithoutCancelFee:
          // If the balance to settle is $1, then it might contradict the minimum value being $1. This is expected behaviour.
          return (
            value <= roundToTwoDecimals(balanceToSettleWithoutCancelFee) ||
            `Cancellation fee must not exceed the balance to settle amount of $${roundToTwoDecimals(
              balanceToSettleWithoutCancelFee
            )}`
          );
        default:
          return true;
      }
    },
  };
};
